// 菜单配置
// headerMenuConfig：头部导航配置
// asideMenuConfig：侧边导航配置

const headerMenuConfig = [
  {
    name: '主页',
    path: '/',
    icon: 'home',
  },
  {
    name: '关于',
    path: '/about',
    icon: 'about',
  }
];

const asideMenuConfig = [];

export { headerMenuConfig, asideMenuConfig };
